// Mobile Menu functionality
class MobileMenu {
  constructor() {
    this.drawer = document.getElementById("mobile-menu-drawer");
    this.toggleButton = document.querySelector("[data-mobile-menu-toggle]");
    this.closeButtons = document.querySelectorAll("[data-mobile-menu-close]");
    this.isOpen = false;
    this.previousFocusElement = null;

    this.init();
  }

  init() {
    // Debug: check if elements exist
    if (!this.toggleButton) {
      console.error("Mobile menu toggle button not found");
      return;
    }
    if (!this.drawer) {
      console.error("Mobile menu drawer not found");
      return;
    }

    this.bindEvents();
    console.log("Mobile menu initialized successfully");
  }

  bindEvents() {
    this.toggleButton.addEventListener("click", () => this.toggle());

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.close());
    });

    // Close on overlay click
    this.drawer.addEventListener("click", (e) => {
      if (
        e.target === this.drawer ||
        e.target.classList.contains("header-mobile__drawer-overlay")
      ) {
        this.close();
      }
    });

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });

    // Trap focus inside drawer when open
    this.drawer.addEventListener("keydown", (e) => {
      if (e.key === "Tab" && this.isOpen) {
        this.trapFocus(e);
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.drawer.hidden = false;
    this.toggleButton.setAttribute("aria-expanded", "true");
    this.drawer.setAttribute("aria-hidden", "false");

    // Store current focus
    this.previousFocusElement = document.activeElement;

    // Move focus to first focusable element in drawer
    const firstFocusable = this.drawer.querySelector(
      "button, a, input, textarea, select"
    );
    if (firstFocusable) {
      firstFocusable.focus();
    }

    // Disable body scroll
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
  }

  close() {
    this.isOpen = false;
    this.toggleButton.setAttribute("aria-expanded", "false");
    this.drawer.setAttribute("aria-hidden", "true");

    // Re-enable body scroll
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";

    // Return focus to previous element
    if (this.previousFocusElement) {
      this.previousFocusElement.focus();
    }

    // Hide drawer after animation
    setTimeout(() => {
      if (!this.isOpen) {
        this.drawer.hidden = true;
      }
    }, 300);
  }

  trapFocus(e) {
    const focusableElements = this.drawer.querySelectorAll(
      'button, a, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }
}

// Initialize when DOM is fully loaded, including deferred content
function initMobileMenu() {
  // Wait a bit to ensure all deferred content is loaded
  setTimeout(() => {
    const toggleButton = document.querySelector("[data-mobile-menu-toggle]");
    const drawer = document.getElementById("mobile-menu-drawer");

    if (toggleButton && drawer) {
      new MobileMenu();
    } else {
      console.warn("Mobile menu elements not found, retrying...");
      // Retry after a short delay
      setTimeout(initMobileMenu, 100);
    }
  }, 50);
}

// Start initialization
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMobileMenu);
} else {
  initMobileMenu();
}
